module.exports = __webpack_public_path__ + "img/vote-next.62e491e3.svg";